import React from "react";
import Skeleton from "react-loading-skeleton";
import { Swiper, SwiperSlide } from "../../../Components/Swiper";

import ContentCardsSkeleton from "../../../Components/ContentCardsSkeleton/ContentCardsSkeleton";
import { CONTENT_SECTIONS } from "../../../config/portalAluno/contentSections";
import "swiper/swiper.min.css";
import "../../../Components/StoryCarousel/styles.css";
import "../page-skeleton.css";

const STORY_PLACEHOLDERS = 50;

const skeletonColors = {
  baseColor: "var(--portal-skeleton-base)",
  highlightColor: "var(--portal-skeleton-highlight)",
};

const HomePageSkeleton = () => (
  <section
    className="content-page portal-home portal-page-skeleton"
    aria-label="Carregando Home"
    aria-busy="true"
  >
    <div className="portal-home__inner">
      <div className="story-carousel" aria-hidden="true">
        <Swiper
          className="story-carousel__track"
          cssMode
          slidesPerView="auto"
          spaceBetween={20}
          breakpoints={{
            0: { spaceBetween: 14 },
            790: { spaceBetween: 20 },
          }}
          freeMode
          freeModeMomentum
          freeModeMomentumBounce={false}
          freeModeMomentumRatio={0.75}
          grabCursor
          speed={360}
          watchOverflow
        >
          {Array.from({ length: STORY_PLACEHOLDERS }, (_, index) => (
            <SwiperSlide key={index}>
              <span className="story-carousel__item portal-page-skeleton__story">
                <span className="story-carousel__ring portal-page-skeleton__story-ring">
                  <span className="story-carousel__avatar portal-page-skeleton__story-avatar">
                    <Skeleton
                      {...skeletonColors}
                      circle
                      className="portal-page-skeleton__story-circle"
                      containerClassName="portal-page-skeleton__story-circle-container"
                    />
                  </span>
                </span>
                <span className="story-carousel__name portal-page-skeleton__story-name">
                  <Skeleton
                    {...skeletonColors}
                    borderRadius={6}
                    className="portal-page-skeleton__story-name-line"
                  />
                </span>
              </span>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="portal-home__sections">
        {CONTENT_SECTIONS.map((section) => (
          <section
            className="portal-page-skeleton__section"
            key={section.kind}
            aria-hidden="true"
          >
            <div className="portal-page-skeleton__section-heading">
              <Skeleton
                {...skeletonColors}
                borderRadius={8}
                className="portal-page-skeleton__section-title"
              />
              <Skeleton
                {...skeletonColors}
                borderRadius={7}
                className="portal-page-skeleton__view-all"
              />
            </div>
            <ContentCardsSkeleton
              count={4}
              layout="row"
              showTitle={false}
            />
          </section>
        ))}
      </div>
    </div>
  </section>
);

export default HomePageSkeleton;
